import { FC } from 'react';
import Link from 'next/link';
import styles from './HeaderBanner.module.scss';
import { DEV_ABSOLUTE_URL } from '@/helpers/variables';

interface IHeaderBannerItemProps {
  url: string | undefined;
  lfrom: string | undefined;
  file_name_1920: string | undefined;
  file_name_450: string | undefined;
}

const HeaderBannerItem: FC<IHeaderBannerItemProps> = ({ url, lfrom, file_name_1920, file_name_450 }) => {
  const BANNER_URL = `${DEV_ABSOLUTE_URL}/static/baner/`;

  return (
    <div className={styles.litresHeaderBanner}>
      <Link prefetch={false} className={styles.litresHeaderBanner__link} target="_blank" href={`${url}?lfrom=${lfrom}`}>
        <img width="1920" height="60" className={styles.litresHeaderBanner__img} src={`${BANNER_URL}${file_name_1920}`} alt="banner" />
        <img width="450" height="100" className={`${styles.litresHeaderBanner__img} ${styles.litresHeaderBanner__img_mobile}`} src={`${BANNER_URL}${file_name_450}`} alt="banner" />
      </Link>
    </div>
  );
};

export default HeaderBannerItem;
